import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { openWindow } from '../../util/redirectUtil';

import ImageForbidden from './ImageForbidden';
class Forbidden extends Component {
    render() {
        return (
            <div className="bg-primary flex h-screen text-center text-gray-600">
                <div className="m-auto">
                    <div className="ml-60 2xl:ml-48">
                        <ImageForbidden />
                    </div>
                    <div className="mt-10">
                        <p className="text-4xl font-bold">Oops... Halaman Tidak Dapat Diakses</p>
                        <p>Maaf, Anda tidak bisa mengakses halaman yang Anda cari.</p>
                        <p>Klik <Link to={openWindow(this.props.userDetail, this.props.history)} className="text-lightblue" id="btnredirect">di sini</Link> untuk kembali.</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetail: state.authentication.userDetail
    };
};

export default withRouter(connect(mapStateToProps, null)(Forbidden));